<div class="dialog-container">
    <div class="dialog-title-block">
        <h2> Low Sock Product Details </h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <div class="dialog-content-block p-3">
        <div class="app-border-grey">
            <div class="implants-list--container position-relative">
                <div class="table-container">
                    <div  class="table-wrapper table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th class="" scope="col">Product Code</th>
                                    <th class="" scope="col">Product name</th>
                                    <th class="" scope="col">Batch Number</th>
                                    <th class="" scope="col">
                                        Expiry Date
                                    </th>
                                </tr> 
                            </thead>
                            <tbody>
                                <tr *ngFor="let product of lowStockList">
                                    <th>{{ product.product_code }}</th>
                                    <td>{{ product.name }}</td>
                                    <td>{{ product.batch_no || product.batch_number || product.batchNumber || product.batch || 'N/A' }}</td>
                                    <td>{{ product.expiry_date }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <app-toast-message></app-toast-message>
            </div>
        </div>
    </div>
</div>